/**
 * Schermteksten in het Pools.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const pl: Teksten = {
  kamerOphalen: "Pobieranie pokoju…",
  kamerWerktNiet: "Ten pokój nie działa",
  serverReageertNiet: "Serwer nie odpowiada",
  probeerOpnieuw: "Spróbuj ponownie",
  vraagNieuweCode: "Poproś osobę, która udostępniła kod, o nowy. Pokój wygasa po kilku godzinach.",
  welkeTaalSprekJij: "W jakim języku mówisz?",
  jouwStem: "Twój głos w tłumaczeniu",
  man: "Mężczyzna",
  vrouw: "Kobieta",
  pincode: "Kod PIN",
  pincodeUitleg: "Otrzymasz go od osoby, która udostępniła kod.",
  gaDeKamerIn: "Wejdź do pokoju",
  kiesEerstJeTaal: "Najpierw wybierz język",
  microfoonAanvragen: "Żądanie mikrofonu…",
  toestemmingUitleg: "Twoja przeglądarka zaraz poprosi o dostęp do mikrofonu. Bez tego możesz tylko pisać.",
  microfoonTestLink: "Najpierw przetestuj mikrofon",
  stemGaatMee: "W tym pokoju druga osoba usłyszy również Twój własny głos, oprócz tłumaczenia.",
  alleenChatMelding: "Ta rozmowa to tylko czat. Piszesz wiadomości i czytasz tłumaczenie; nic nie jest odczytywane na głos.",
  verlooptOm: "Wygasa o",
  nooitVasteKamer: "Nigdy, stały pokój",
  kamer: "Pokój",
  tolkgesprek: "Rozmowa z tłumaczem",
  juisteKamer: "Jesteś we właściwym pokoju. Za chwilę będziesz móc dołączyć do rozmowy.",
  jij: "ty",
  deAnder: "druga osoba",
  verbinden: "Łączenie…",
  verbonden: "Połączono",
  verbindingKwijt: "Połączenie przerwane. Ponawianie próby…",
  wachtenOpAnder: "Jesteś w środku. Poczekaj, aż druga osoba zeskanuje kod QR.",
  allebeiInDeKamer: "Oboje jesteście w pokoju.",
  anderIsWeg: "Druga osoba wyszła",
  anderSpreekt: "Druga osoba mówi…",
  jeKuntErNietIn: "Nie możesz wejść",
  overgenomenTitel: "Kontynuacja na innym urządzeniu",
  overgenomenUitleg: "Ta rozmowa została właśnie otwarta na innym urządzeniu. Tam możesz ją kontynuować.",
  terug: "Wstecz",
  geluidStaatUit: "Dźwięk jest wyłączony. Dotknij ekranu w dowolnym miejscu.",
  tikHier: "dotknij tutaj",
  bewaardTot: 'Zapisane do {tijd}',
  bewaardVast: "Stały pokój. Wiadomości są przechowywane przez 30 dni.",
  spreekIn: "Mów",
  luisteren: "Słuchanie… dotknij, aby zatrzymać",
  uitschrijven: "Zapisywanie tekstu…",
  tijdOmTeVerbeteren: "Czas na poprawki",
  altijdZelfVersturen: "Zawsze sprawdzaj i wysyłaj samodzielnie",
  jijVerstuurtZelf: "Wysyłasz samodzielnie",
  uit: "wył.",
  sec: "sek",
  vertalingMeteenAfspelen: "Odtwarzaj tłumaczenie od razu",
  typHierJeBericht: "Wpisz tutaj swoją wiadomość…",
  stuur: "Wyślij",
  geenOpnameMogelijk: "Ta przeglądarkarka nie może nagrywać dźwięku. Możesz pisać.",
  verstaanAls: "Zrozumiano jako",
  tellerStaatStil: "licznik zatrzymany",
  versturen: "Wyślij",
  wis: "Wyczyść",
  jijZei: "ty mówisz",
  vertaald: "przetłumaczone",
  duimOmhoog: "To się zgadza",
  duimOmlaag: "To się nie zgadza",
  opnieuwProberenKnop: "Spróbuj ponownie z lepszym modelem",
  opnieuwProberenBezig: "Ponowne tłumaczenie…",
  duimTranscriptWoordenlijstUitnodiging: "Źle zrozumiane? Popraw to w słowniku:",
  instellingenAanpassen: "Zmień ustawienia",
  geldtVoorJullieBeiden: "Dotyczy was obojga",
  alleenVoorJou: "Tylko dla ciebie",
  stuurMijnStemMee: "Przesyłaj mój własny głos",
  verbeterSpelfouten: "Poprawiaj błędy ortograficzne w moim tekście",
  verbeterSpelfoutenUit: "Wyłączenie tej opcji pokaże dokładnie to, co zostało usłyszane, wraz z błędami.",
  alleenChat: "Tylko czat: bez mowy, bez mikrofonu",
  alleenChatUitleg: "Oboje piszecie. Widać tłumaczenie i tekst oryginalny; nic nie jest odczytywane na głos.",
  aangepastDoorDeAnder: "Druga osoba zmieniła ustawienia.",
  foutSpraak: "Tłumaczenie jest gotowe, ale nie było słychać głosu.",
  foutSpraakQuota: "Dzisiejszy limit mowy został wyczerpany. Tekst nadal działa; głos wróci jutro.",
  foutBudgetKamer: "Ta rozmowa osiągnęła swój limit, więc tłumaczenie jest wstrzymane. Osoba, która ją utworzyła, może go zwiększyć; wtedy od razu znów działa.",
  foutBudgetMaand: "Miesięczny budżet aplikacji się wyczerpał. Tłumaczenie wróci, gdy administrator go dostosuje.",
  foutTaal: "Ten język jest niedostępny: oboje mówilibyście w tym samym języku.",
  origineel: "oryginał",
  vertalen: "Tłumaczenie…",
  vertalenMislukt: "Tłumaczenie nie powiodło się.",
  opnieuwAfspelen: "Odtwórz tłumaczenie ponownie",
  hoorDeAnder: "Posłuchaj, jak druga osoba to powiedziała",
  woordenlijst: "Słownik awaryjny",
  woordenlijstUitleg: "Czy aplikacja stale błędnie rozumie nazwę lub termin techniczny? Zapisz tutaj, o co chodzi.",
  hijHoort: "aplikacja słyszy…",
  jijBedoelt: "ty masz na myśli…",
  ookVolgendeGesprekken: "Również w kolejnych rozmowach — inaczej obowiązuje tylko tutaj",
  voegToe: "Dodaj",
  bezig: "W toku…",
  lijstNietGeladen: "Nie udało się załadować listy.",
  toevoegenMislukt: "Dodawanie nie powiodło się.",
  verwijderenMislukt: "Usuwanie nie powiodło się.",
  overal: "wszędzie",
  verwijder: "Usuń",
  overDitGesprek: "O tej rozmowie",
  toon: "Ton tłumaczenia",
  sfeer: "Atmosfera rozmowy",
  jouwPlek: "Twoje miejsce",
  hoeHetWerkt: "Serwer zapisuje Twoje nagranie i tłumaczy je za jednym razem. Twój własny głos jest przesyłany do drugiej osoby.",
  kleinereTekst: "Mniejszy tekst",
  grotereTekst: "Większy tekst",
  insprekenVerbergen: "Ukryj nagrywanie",
  insprekenTonen: "Pokaż nagrywanie",
  toetsenbordVerbergen: "Ukryj klawiaturę",
  toetsenbordTonen: "Pokaż klawiaturę",
  vormAutomatisch: "Automatycznie",
  vormInformeel: "Ty",
  vormFormeel: "Pan/Pani",
  sfeerNeutraal: "Neutralna",
  sfeerZakelijk: "Biznesowa",
  sfeerOfficieel: "Oficjalna",
  sfeerVriendschappelijk: "Przyjacielska",
  sfeerPartner: "Partner",
  foutKamerVol: "Ten pokój jest pełny. Mogą w nim przebywać tylko dwie osoby.",
  plekBezetTitel: "Twoje miejsce jest zajęte",
  plekBezetUitleg: "Ktoś już jest po twojej stronie tej rozmowy, w twoim języku. Zwykle to ty: rozmowa jest wciąż otwarta na innym urządzeniu lub w innej karcie. Zamknij ją tam i spróbuj ponownie. Czasem trwa półtorej minuty, zanim miejsce się zwolni.",
  plekBezetWissel: "To ty? Wpisz WISSEL, aby przenieść rozmowę na to urządzenie. Drugie urządzenie zostanie wtedy zamknięte.",
  plekBezetKnop: "Przenieś na to urządzenie",
  foutKamerVerlopen: "Ten pokój wygasł lub został zamknięty.",
  foutKamerOnbekend: "Ten pokój nie istnieje.",
  foutPinNodig: "Ten pokój wymaga kodu PIN.",
  foutPinFout: "Kod PIN jest nieprawidłowy.",
  foutProtocol: "Aplikacja i serwer nie mogą się porozumieć. Odśwież stronę.",
  foutMicroGeweigerd: "Odmówiono dostępu do mikrofonu. Kliknij ikonę kłódki w pasku adresu i włącz go.",
  foutGeenMicro: "Nie znaleziono mikrofonu. Podłącz go i spróbuj ponownie.",
  foutMicroInGebruik: "Mikrofon jest używany przez inny program. Zamknij go i spróbuj ponownie.",
  foutGeenHttps: "Mikrofon działa tylko przy bezpiecznym połączeniu. Otwórz tę stronę przez https.",
  foutMicroOnbekend: "Nie udało się uruchomić mikrofonu.",
  foutNietsOpgenomen: "Nic nie nagrano. Czy Twój mikrofon jest włączony?",
  foutNietsGehoord: "Nic nie usłyszano. Czy Twój mikrofon jest włączony i mówisz wystarczająco głośno?",
  foutOpnameTeLang: "To nagranie jest za długie. Mów krótszymi fragmentami.",
  foutMicroGedempt: "Twój mikrofon jest wyciszony. Włącz go i spróbuj ponownie.",

  // --- microfoontest ---
  micTitel: "Test mikrofonu",
  micOnderschrift: "Cztery testy po kolei, każdy po pięć sekund. Mów przez cały czas.",
  micStart: "Uruchom test",
  micTest1: "1. Tylko rozpoznawanie",
  micTest2: "2. Tylko nagrywanie",
  micTest3: "3. Razem — najpierw nagrywanie",
  micTest4: "4. Razem — najpierw rozpoznawanie",
  micFase1: "1 z 4: tylko rozpoznawanie — powiedz krótkie zdanie",
  micFase2: "2 z 4: tylko nagrywanie — mów dalej",
  micFase3: "3 z 4: najpierw nagrywanie, potem rozpoznawanie — mów dalej",
  micFase4: "4 z 4: najpierw rozpoznawanie, potem nagrywanie — mów dalej",
  micKlaar: "gotowe",
  micGehoord: "usłyszano",
  micOpnameformaat: "Format nagrania",
  micGeen: "brak",
  micBeveiligd: "Bezpieczne połączenie",
  micJa: "tak",
  micNee: "NIE",
  micBrowser: "Przeglądarka",
  micGeenHttps: "Bez https przeglądarka nie udostępni mikrofonu. Na localhost jest to dozwolone.",
  micGeenHerkenning: "Ta przeglądarka nie ma rozpoznawania mowy.",
  micZegIets: "powiedz coś…",
  micWoordenBinnen: "słowa przychodzą",
  micKonNietStarten: "nie udało się uruchomić",
  micGeenRecorder: "Ta przeglądarka nie zna MediaRecorder.",
  micOpnemen: "nagrywanie…",
  micNietsOpgenomen: "nic nie nagrano",
  micGeenMicrofoon: "brak mikrofonu",
  micOpnameEerst: "najpierw nagrywanie…",
  micHerkenningEerst: "najpierw rozpoznawanie…",
  micOpnameStarttNiet: "nagrywanie nie wystartowało",
  micSamenGelukt: "Razem. Nagranie {kb} kB.",
  micAlleenOpname: "Nagrywanie tak, rozpoznawanie nie.",
  micAlleenHerkenning: "Rozpoznawanie tak, nagrywanie nie.",
  micGeenVanBeide: "Żadne z dwóch.",
  micNetwerkFout: "Rozpoznawanie mowy nie mogło połączyć się z serwerem.",
  micAfgebroken: "Nagrywanie zostało przerwane.",
  verslagTitel: "Protokół rozmowy",
  verslagWie: "Kto",
  verslagOrigineel: "Oryginał",
  verslagVertaling: "Tłumaczenie",
  verslagSpreker: "Rozmówca {x}",
  verslagBerichten: "Wiadomości",
  verslagGemaaktOp: "Utworzono",
  verslagGeenOpname: "To nie jest dosłowne nagranie.",
  verslagNootOrigineel: "„Oryginał” to tekst w takiej formie, w jakiej aplikacja zrozumiała mówiącego.",
  verslagNootCorrectie: "Korekta pisowni była włączona: drobne literówki zostały poprawione.",
  verslagNootAangepast: "Osoba mówiąca mogła jeszcze zmienić tekst przed wysłaniem.",
  verslagGesproken: "mówione",
  verslagGetypt: "pisane",
  verslagMislukt: "Tłumaczenie nie powiodło się. Druga osoba nie zobaczyła tego zdania w swoim języku.",
  verslagNietKlaar: "Tłumaczenie nie było jeszcze gotowe, gdy utworzono ten protokół.",
  verslagVertrouwelijk: "Poufne.",
  verslagAlleenDeelnemers: "Ten protokół zawiera treść prywatnej rozmowy i jest przeznaczony wyłącznie dla jej uczestników.",
  verslagGewist: "Termin usunięcia rozmowy: {tijd}. Potem nie będzie można ponownie utworzyć tego protokołu.",
  verslagGewistVast: "Stały pokój: każda wiadomość jest usuwana 30 dni po wysłaniu. Starszych wiadomości nie ma w tym protokole.",
};
